import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { FiCopy, FiCheck } from "react-icons/fi";
import ImageURL from "../../config/ImageURL";
import Select from "react-select";
import api from "../../config/URL";

function GenerateLink() {
  const [show, setShow] = useState(false);
  const [pastedLink, setPastedLink] = useState("");
  const [generatedLink, setGeneratedLink] = useState("");
  const [error, setError] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [activeTab, setActiveTab] = useState("paste_link"); // Track active tab
  const [options, setOptions] = useState([]);
console.log(options);
  const resetData = () => {
    setPastedLink("");
    setGeneratedLink("");
    setError("");
    setCopySuccess(false);
    setSelectedProduct(null);
  };

  const handleClose = () => {
    setShow(false);
    resetData();
  };

  const handleShow = () => {
    setShow(true);
    getOptionList();
  };

  const getOptionList = async () => {
    try {
      const response = await api.get("/affiliate/getAllProductList");
      setOptions(response.data.data);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  const copyToClipboard = () => {
    if (generatedLink) {
      navigator.clipboard.writeText(generatedLink).then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      });
    }
  };

  const generateAffiliateLink = (customLink = "") => {
    setError("");
    setGeneratedLink("");
    setCopySuccess(false);

    const affiliateCode = localStorage.getItem("affiliate_code");
    const linkToUse = customLink || pastedLink.trim();

    if (!linkToUse) {
      setError("Please paste a product link or select a product.");
      return;
    }

    if (!affiliateCode) {
      setError("Affiliate code not found.");
      return;
    }

    const escapedBaseURL = ImageURL.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    const pattern = new RegExp(`^${escapedBaseURL}[^/\\s]+/?$`);

    if (!pattern.test(linkToUse)) {
      setError("Only product links are allowed.");
      return;
    }

    const hasQuery = linkToUse.includes("?");
    const connector = hasQuery ? "&" : "?";
    const finalLink = `${linkToUse}${connector}affid=${affiliateCode}`;

    setGeneratedLink(finalLink);
  };

  return (
    <>
      <button
        className="btn mt-4 mx-4"
        onClick={handleShow}
        style={{ background: "#ff0060", color: "#fff", boxShadow: "none" }}
      >
        Generate Affiliate Link
      </button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="pt-4 pb-0 border-0">
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => {
              setActiveTab(k);
              resetData(); // Reset data on tab change
            }}
            transition={false}
            id="noanim-tab-example"
            className="mb-3"
          >
            {/* Paste Link Tab */}
            <Tab eventKey="paste_link" title="Paste Link">
              <div className="mb-3">
                <label htmlFor="productLink" className="form-label">
                  Paste Product Link
                </label>
                <textarea
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id="productLink"
                  rows="3"
                  value={pastedLink}
                  onChange={(e) => setPastedLink(e.target.value)}
                ></textarea>
                {error && <div className="invalid-feedback">{error}</div>}
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => generateAffiliateLink()}
                >
                  Generate Affiliate Link
                </button>
              </div>

              {generatedLink && (
                <div className="mt-4">
                  <label className="form-label">Generated Link</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={generatedLink}
                      readOnly
                    />
                    <button
                      className={`btn ${
                        copySuccess ? "btn-success" : "btn-outline-secondary"
                      } d-flex align-items-center`}
                      type="button"
                      onClick={copyToClipboard}
                    >
                      {copySuccess ? (
                        <>
                          <FiCheck className="me-1" />
                          Copied
                        </>
                      ) : (
                        <>
                          <FiCopy className="me-1" />
                          Copy
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </Tab>

            {/* Product Selection Tab */}
            <Tab eventKey="product" title="Select Product">
              <Select
                options={options}
                name="product_slug"
                value={selectedProduct}
                onChange={(selected) => {
                  setSelectedProduct(selected);
                  const productLink = `${ImageURL}${selected.value}`;
                  generateAffiliateLink(productLink);
                }}
                placeholder="Search & select product..."
                isSearchable
              />
              {generatedLink && (
                <div className="mt-4">
                  <label className="form-label">Generated Link</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={generatedLink}
                      readOnly
                    />
                    <button
                      className={`btn ${
                        copySuccess ? "btn-success" : "btn-outline-secondary"
                      } d-flex align-items-center`}
                      type="button"
                      onClick={copyToClipboard}
                      style={{ zIndex: "1" }}
                    >
                      {copySuccess ? (
                        <>
                          <FiCheck className="me-1" />
                          Copied
                        </>
                      ) : (
                        <>
                          <FiCopy className="me-1" />
                          Copy
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default GenerateLink;
